(function($, window){
    // Typography
    // Prevent widows in headers

    // $('h1, h2, h3').not('#hero h2, .card h3').add('#main-content p').not('.fact-list p').contents()
    //     .filter(function(){
    //         return this.nodeType == 3;
    //     })
    //     .each((i, el) => {
    //         // let trimmedText = $.trim(el.data);
    //         let trimmedText = el.data;
    //         let lastSpace = trimmedText.lastIndexOf(' ');
    //         if (lastSpace == -1) {
    //             return;
    //         }
    //         el.data = trimmedText.substring(0, lastSpace) + '\u00a0' + trimmedText.substring(lastSpace + 1);
    //     });

    $('h1, h2, h3').not('#hero h2, .card h3').add('#main-content p').not('.fact-list p').each(function(){
        let el = $(this).contents().filter(function(){
            return this.nodeType == 3;
        }).last().get(0);
      
        if (!el) {return;}

        // let trimmedText = $.trim(el.data);
        let trimmedText = el.data;
        let lastSpace = trimmedText.lastIndexOf(' ');
        if (lastSpace == -1) {
            return;
        }
        el.data = trimmedText.substring(0, lastSpace) + '\u00a0' + trimmedText.substring(lastSpace + 1);
      
    });
        

})(jQuery, window);